/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

class ShippingTimes {
    constructor() {
        this.valueElement = document.querySelector('[data-shipping-value]');
        this.translations = {
            days: 'jour(s)',
            hours: '24 heures'
        };
        
        // Initialize event listeners
        this.init();
    }
    
    init() {
        document.addEventListener('on:variant:change', (event) => {
            const variant = event.detail.variant;
            const shippingDays = window.variantsShippingData?.[variant.id];
            this.updateShippingDisplay(shippingDays);
        });
    }
    
    updateShippingDisplay = (shippingDays) => {
        if (!this.valueElement) return;
        
        if (shippingDays && shippingDays > 0) {
            this.valueElement.textContent = `${shippingDays} ${this.translations.days}`;
        } else {
            this.valueElement.textContent = this.translations.hours;
        }
    }
}

new ShippingTimes();
